require('dotenv').config();
export default {
    API_FOLDERS: 'https://nameless-temple-32242.herokuapp.com/api/folders',
    API_NOTES:'https://nameless-temple-32242.herokuapp.com/api/notes',
    API_KEY: process.env.REACT_APP_API_KEY,
  }